import React, { Fragment } from 'react'

import moment from 'moment'
import numeral from 'numeral'

import PropTypes from 'prop-types'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import AboutDesigner from './AboutDesigner'
import MessageFiles from './MessageFiles'
import MessageImages from './MessageImages'
import MessageRating from './MessageRating'

function resolveAuthor(message, included, systemMessageAvatarUrl) {
  if (message.attributes.systemMessage) {
    return {
      attributes: {
        username: 'Project Assistant',
        avatar: { url: systemMessageAvatarUrl },
      },
    }
  }
  return (
    included.find(include => include.id === message.relationships.user.data.id && include.type === 'conversationUsers')
  )
}

function Message({
  message,
  included = EMPTY_ARRAY,
  isFirstUnreadMessage,
  systemMessageAvatarUrl = null,
}) {
  const attachmentIds = message.relationships.attachments.data.map(attachment => attachment.id)
  const images = included.filter(include => include.type === 'attachments' && include.attributes.contentType == 'image' && attachmentIds.includes(include.id))
  const files = included.filter(include => include.type === 'attachments' && include.attributes.contentType == 'file' && attachmentIds.includes(include.id))
  const author = resolveAuthor(message, included, systemMessageAvatarUrl)

  const popularItems = included.filter(include => include.type === 'listingItem' && include.attributes.authorUsername === author.attributes.username)

  let className = `main-content__message ${message.attributes.isReceived ? 'main-content__message--recieved' : 'main-content__message--sent'}`
  className += message.attributes.systemMessage ? ` main-content__message--${message.attributes.style}` : ''

  const newMessageLabel = (
    <div className="new-messade-indicator">
      <span className="new-messade-indicator__message">New message</span>
    </div>
  )

  return (
    <Fragment>
      {isFirstUnreadMessage && newMessageLabel}
      <div className={className}>
        {author.attributes.username !== 'Project Assistant' && (
          <div className="message__header">
            <div className="message-author">
              {message.attributes.isReceived ? (
                <span className="author author~--small">
                  <a href={`/${author.attributes.username}`}>
                    <UserAvatar
                      size="small"
                      img={author.attributes.avatar.url}
                      userName={author.attributes.username}
                    />
                    <span>{author.attributes.username}</span>
                  </a>
                </span>
              ) : (
                <span className="author author--small">
                  <span>You</span>
                </span>
              )}
            </div>
            <span className="message-time u-float-right">
              {moment.unix(message.attributes.date).format('YYYY-MM-DD HH:mm')}
            </span>
          </div>
        )}

        {message.attributes.aboutDesigner && (
          <AboutDesigner data={message.attributes.aboutDesigner} popularItems={popularItems} />
        )}

        <div className="card card--flat message__content">
          {message.attributes.rating && (
            <Fragment>
              <MessageRating rating={message.attributes.rating} />
              <p className="message__title"><strong>Comment</strong></p>
            </Fragment>
          )}

          {(message.attributes.priceOffer || message.attributes.aboutDesigner) && (
            <p className="message__title"><strong>Offer</strong></p>
          )}

          <p className="message__description" dangerouslySetInnerHTML={{ __html: message.attributes.message }} />
          {message.attributes.aboutDesigner && (
            <p className="message__description">
              <strong>Price Offer: {numeral(message.attributes.aboutDesigner.initialPriceOffer).format('$0.00')}</strong>
            </p>
          )}

          {message.attributes.priceOffer && (
            <section className="message-pricing">
              <p>
                <strong>Pricing</strong>
              </p>
              <p>
                <span className="message-pricing__item">
                  Offer <strong>{numeral(message.attributes.priceOffer.price).format('$0.00')}</strong>
                </span>
                {message.attributes.priceOffer.revenue && (
                  <span className="message-pricing__item">
                    Revenue <strong>{numeral(message.attributes.priceOffer.revenue).format('$0.00')}</strong>
                  </span>
                )}
              </p>
            </section>
          )}

          {(files.length > 0 || images.length > 0) && (
            <div className="message__attachments row">
              <MessageFiles files={files} />
              <MessageImages attachments={images} />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  )
}

Message.propTypes = {
  message: PropTypes.shape({
    attributes: PropTypes.shape({
      date: PropTypes.number.isRequired,
      message: PropTypes.string.isRequired,
      isReceived: PropTypes.bool,
      isFirstUnread: PropTypes.bool,
      rating: PropTypes.number,
      initialPriceOffer: PropTypes.number,
      priceOffer: PropTypes.shape({
        price: PropTypes.number.isRequired,
        revenue: PropTypes.number,
      }),
    }).isRequired,
    relationships: PropTypes.shape({
      attachments: PropTypes.object.isRequired,
      user: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  included: PropTypes.array,
  isFirstUnreadMessage: PropTypes.bool.isRequired,
  systemMessageAvatarUrl: PropTypes.string,
}

export default Message
